module.exports = __webpack_public_path__ + "img/logout.31199b21.svg";